import type { HTMLProps } from 'react';

import { cn } from '~/chords/lib/cn';
import { variants } from '~/chords/lib/variants';

import type { ComponentProps } from '../ComponentProps';
import { getClassNameOverride } from '../getClassNameOverride';
import { State } from './types';

interface FieldMessageProps
  extends ComponentProps<HTMLProps<HTMLParagraphElement>> {
  state?: keyof typeof State;
}

const fieldMessage = variants({
  base: ['text-body-sm', 'text-default'],
  variants: {
    state: {
      default: ['text-default'],
      valid: ['text-success-default'],
      invalid: ['text-error-default'],
      disabled: ['text-disabled'],
      warning: ['text-warning-default'],
    },
  },
});

export function FieldMessage({
  children,
  state = 'default',
  ...props
}: FieldMessageProps) {
  const className = getClassNameOverride(props);
  const {
    dangerouslyOverrideClassName: _dangerouslyOverrideClassName,
    ...propsWithoutClassName
  } = props;

  return (
    <p
      {...propsWithoutClassName}
      className={cn(fieldMessage({ state }), className)}
    >
      {children}
    </p>
  );
}

FieldMessage.displayName = 'FieldMessage';
FieldMessage.State = State;
